import defaultAssets from './assets'
import defaultEmbeddedEntry from './embedded-entry'

export default {
  ...defaultAssets,
  ...defaultEmbeddedEntry,
}
